import {
  GxButton,
  GxIcon, GxSpinner
} from '@garpix/garpix-web-components-react';
import cn from 'classnames';
import React, {FC, useEffect, useMemo, useState} from 'react';
import { toast } from 'react-toastify';
import { useStoreon } from 'storeon/react';
import { Events, State } from '@/interfaces';
import { ITaskState } from '@/types';
import { api } from '@/api';
import { TYPE_USER } from '@/const';
import {
  AlertIcon,
  CloseIcon, DeleteChecked, DeleteIcon,
  PrinterIcon
} from '../../../../assets';
import Button from '../../../../components/Button';
import Checkbox from '../../../../components/Checkbox';
import Pagination from '../../../../components/Pagination';
import useModalFlag from '../../../../hooks/useModalFlag';
import dayjs from '../../../../utils/dayjs';
import { TYPES_TASK } from '../../../Applications/consts';
import { getCheckedItem } from '../../../Applications/helpers';
import ModalChangeTask from '../ModalChangeTask';
import styles from './styles/index.module.scss';

const TableTasks: FC = () => {
  const { dispatch, tasks, taskInfo, statusLoadTasks, currentUser } = useStoreon<State, Events>('tasks','taskInfo', 'statusLoadTasks', 'currentUser');
  const [currentTask, setCurrentTask] = useState<ITaskState>()
  const [activePage, setActivePage] = useState<number>(taskInfo.page)
  const checkedItem = useMemo(() => getCheckedItem(tasks.results), [tasks.results])
  const checkedCount = checkedItem.length;
  const { flag, setModalFlag } = useModalFlag()

  const handleChange = (id: number) => {
    return () => {
      const [res] = tasks.results.filter((task) => {
        return task.id === id
      })
      setCurrentTask(res)
      setModalFlag()
    }
  }

  const removeTask = async (listId: number[]) => {
    const tasksNames = checkedItem.map((item: any) => {
      return (item.title)
    }).join(',')
    try {
      await api.task.removeTasks(listId)
      dispatch('taskInfo/set', { page: 1 })
      dispatch('taskInfo/getCount')
      dispatch('tasks/get')
    } catch (e) {
      toast.error(checkedCount > 1 ?
        `Задачи: "${tasksNames}" не были удалены!` :
        `Задача: "${tasksNames}" не была удалена!`
      );
      console.log(e);
    }
  }

  const closeTask = async (id: number, title: String) => {
    try {
      await api.task.closeTask(id)
      dispatch('tasks/get')
    } catch {
      toast.error(`Задачa: "${title}" не была закрыта!`)
    }
  }

  const handleRemoveTask = async () => {
    const listId = checkedItem.map((item) => {
      return (item.id)
    })
    removeTask(listId)
  }


  const handleCloseTask = () => {
    if (checkedItem.length) {
      checkedItem.map((item: any) => {
        return closeTask(item.id, item.title)
      })
    }
  }

  const handleChangePage = (page: number) => {
    setActivePage(page)
    dispatch('taskInfo/set', { page });
    dispatch('tasks/get');
  }
  
  useEffect(() => {
    dispatch('tasks/get')
  }, [])
  

  useEffect(()=>{
    setActivePage(taskInfo.page ? taskInfo.page : 1)
  },[taskInfo])


  return (
    <>
        <div className={styles['table-header']}>
          <div className={styles['table-header--left_block']}>
            <Checkbox
              handleChange={() => dispatch('changeCheckedTasks/set', checkedCount === 0 ? 'all' : 'takeOf')}
              name='multi-checkbox'
              checked={checkedCount !== 0}
            />
            <span className={styles['table-header--count']}>{checkedCount}</span>
            <GxButton onClick={() => dispatch('changeCheckedTasks/set', 'takeOf')} className={styles['btn']}>
              <GxIcon className={styles['icon']} src={DeleteChecked} />
              <span>Снять выделенное</span>
            </GxButton>
            <div className={styles['toolbar']}>
              <GxButton className={styles['btn']}>
                <GxIcon className={styles['icon']} src={PrinterIcon} />
                <span>Печать</span>
              </GxButton>

              <GxButton onClick={handleCloseTask} className={styles['btn']}>
                <GxIcon className={styles['icon']} src={CloseIcon} />
                <span>Закрыть</span>
              </GxButton>
              {currentUser.user_status === TYPE_USER.SUPERUSER && (
              <GxButton onClick={handleRemoveTask} className={styles['btn']}>
                <GxIcon className={styles['icon']} src={DeleteIcon} />
                <span>Удалить</span>
              </GxButton>
              )}
            </div>
          </div>
        </div>
        <div className={styles['content']}>
          {tasks.results.length === 0 ?
              <div className={styles['info']}>
                <span>Задачи отсутствуют...</span>
              </div>
              :
              <table className={styles['table']}>
                <thead>
                <tr className={styles['table--header-row']}>
                  <th/>
                  <th>
                    Недавние задачи
                  </th>
                  <th>
                    Исполнитель
                  </th>
                  <th>
                    Тип задачи
                  </th>
                  <th>Дата и время окончания</th>
                  <th>Дата и время создания</th>
                  <th>Статус</th>
                  <th>Файл</th>
                </tr>
                </thead>
                <tbody>
                {!statusLoadTasks && tasks && tasks.results.map((task: Record<string, any>) => (
                    <tr key={task.id}>
                      <td width={75}>
                        <div  className={styles['table__info']}>
                          <Checkbox handleChange={() => dispatch('changeCheckedTasks/set', task.id)} name='check'
                                    checked={task.checked}/>
                          {task.is_urgent &&  <GxIcon src={AlertIcon} className={styles['table__info--icon']}/>}
                        </div>
                      </td>
                      <td className={styles['table__item--name']}>
                        <Button theme='btn--transparent_link' type='button' className={styles['btn--transparent_link']}
                                onClick={handleChange(task.id)}>{task.title}</Button>
                      </td>
                      <td>{task.fio}</td>
                      <td>{TYPES_TASK[task.source]}</td>
                      <td>{task.deadline_at ? dayjs(task.deadline_at).format('D MMMM YYYY г. HH:mm') : '-'}</td>
                      <td>{task.created_at ? dayjs(task.created_at).format('D MMMM YYYY г. HH:mm') : '-'}</td>
                      <td>
                    <span
                        className={cn(
                            styles['table__item--status'],
                            {
                              [styles[`table__item--status_${task.state_status}`]]: task.state_status
                            }
                        )}>
                      {task.state}
                    </span>
                      </td>
                      <td className={styles['table__item--link']}>
                        {task.attach &&
                        <>
                          <div className={styles['table__item--file-name']}>{task.attach_name}</div>
                          <Button
                              className={styles['table__item--btn-link']}
                              theme='btn--transparent_link'
                              href={task.attach}
                              download
                          >
                            Скачать
                          </Button>
                        </>
                        }
                      </td>
                    </tr>
                ))}
                </tbody>
              </table>
          }
          {statusLoadTasks && <div className={styles['content--status']}> <GxSpinner style={{ fontSize: '5rem' }} /></div>}
        </div>
      <div className={styles['pagination']}>
        <Pagination
            onChange={(page: number) => handleChangePage(page)}
            total={tasks.count}
            pageSize={10}
            activePage={activePage}
        />
      </div>

      <ModalChangeTask currentTask={currentTask} flag={flag} setModalFlag={setModalFlag} />
    </>
  )
};

export default TableTasks;
